import { ATBaseClient } from '@src/services/ATBaseClient';

const atBaseClient = new ATBaseClient();

/**
 * AuthenticatedRequestsClient
 * This module is responsible for calling @AuthenticatedRequestHandler in Seaward. This can be used by
 * tools and services (that depend on IhmCrookHook) to make calls to underlying services protected by various
 * authentication mechanisms. Currently, we support Midway and IhmLogin.
 */
export class AuthenticatedRequestsClient {
    /**
     * Calls AuthenticatedRequestHandler.raw in Seaward with the config passed as the argument.
     * Returns a Promise that resolves to the response and rejects with a {@see SeawardException}.
     */
    public static crossFrameRequestRaw(config: object, extraOptions?) {
        return AuthenticatedRequestsClient.makeATBaseCall('raw', config, extraOptions);
    }

    /**
     * Makes the cross frame call to Seaward.
     */
    private static makeATBaseCall(action, parameters, extraOptions?) {
        return atBaseClient.call('authenticatedRequestsServiceListener', action, parameters, extraOptions);
    }
}
